import { LOCATION } from "../Actions/Utilites";


const INITIAL_STATE = {
  // Add Location
  addLocationLoading: false,
  addLocationSuccess: false,
  addLocationFailure: false,
  addLocationError: null,

  //   Get ALl Location
  getAllLocationLoading: false,
  getAllLocationSuccess: false,
  getAllLocationFailure: false,
  getAllLocationError: null,
  getAllLocation: [],

  //   Get Location
  getLocationLoading: false,
  getLocationSuccess: false,
  getLocationFailure: false,
  getLocationError: null,
  getLocation: [],

  //   Update Location
  updateLocationLoading: false,
  updateLocationSuccess: false,
  updateLocationFailure: false,
  updateLocationError: null,
  updateLocation: [],

  //   Delete Location
  deleteLocationLoading: false,
  deleteLocationSuccess: false,
  deleteLocationFailure: false,
  deleteLocationError: null,
  deleteLocation: [],
};

export const LocationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Add Location
    case LOCATION.ADD_LOCATION_REQUEST:
      return {
        ...state,
        addLocationLoading: true,
        addLocationSuccess: false,
        addLocationFailure: false,
        addLocationError: null,
      };
    case LOCATION.ADD_LOCATION_SUCCESS:
      return {
        ...state,
        addLocationLoading: false,
        addLocationSuccess: true,
        addLocationFailure: false,
        addLocationError: null,
        getAllLocation: [...state.getAllLocation, action.payload.result],
      };
    case LOCATION.ADD_LOCATION_FAILURE:
      return {
        ...state,
        addLocationLoading: false,
        addLocationSuccess: false,
        addLocationFailure: true,
        addLocationError: action.payload,
      };

    //   Get All Location
    case LOCATION.GET_ALL_LOCATION_REQUEST:
      return {
        ...state,
        getAllLocationLoading: true,
        getAllLocationSuccess: false,
        getAllLocationFailure: false,
        getAllLocationError: null,
      };
    case LOCATION.GET_ALL_LOCATION_SUCCESS:
      return {
        ...state,
        getAllLocationLoading: false,
        getAllLocationSuccess: true,
        getAllLocationFailure: false,
        addAllLocationError: null,
        getAllLocation: action.payload.result,
      };
    case LOCATION.GET_ALL_LOCATION_FAILURE:
      return {
        ...state,
        getAllLocationLoading: false,
        getAllLocationSuccess: false,
        getAllLocationFailure: true,
        getAllLocationError: action.payload,
      };

    // Get Location
    case LOCATION.GET_LOCATION_REQUEST:
      return {
        ...state,
        getLocationLoading: true,
        getLocationSuccess: false,
        getLocationFailure: false,
        getLocationError: null,
      };
    case LOCATION.GET_LOCATION_SUCCESS:
      return {
        ...state,
        getLocationLoading: false,
        getLocationSuccess: true,
        getLocationFailure: false,
        addLocationError: null,
        getLocation: action.payload.result,
      };
    case LOCATION.GET_LOCATION_FAILURE:
      return {
        ...state,
        getLocationLoading: false,
        getLocationSuccess: false,
        getLocationFailure: true,
        getLocationError: action.payload,
      };

    // Update Note
    case LOCATION.UPDATE_LOCATION_REQUEST:
      return {
        ...state,
        updateLocationLoading: true,
        updateLocationSuccess: false,
        updateLocationFailure: false,
        updateLocationError: null,
      };
    case LOCATION.UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        updateLocationLoading: false,
        updateLocationSuccess: true,
        updateLocationFailure: false,
        updateLocationError: null,
        updateLocation: action.payload,
      };
    case LOCATION.UPDATE_LOCATION_FAILURE:
      return {
        ...state,
        updateLocationLoading: false,
        updateLocationSuccess: false,
        updateLocationFailure: true,
        updateLocationError: action.payload,
      };

    // Delete Note
    case LOCATION.DELETE_LOCATION_REQUEST:
      return {
        ...state,
        deleteLocationLoading: true,
        deleteLocationSuccess: false,
        deleteLocationFailure: false,
        deleteLocationError: null,
      };
    case LOCATION.DELETE_LOCATION_SUCCESS:
      const result = state.getAllLocation.filter(
        (note) => note.id !== action.payload.result
      );
      return {
        ...state,
        deleteLocationLoading: false,
        deleteLocationSuccess: true,
        deleteLocationFailure: false,
        deleteLocationError: null,
        getAllLocation: result,
      };
    case LOCATION.DELETE_LOCATION_FAILURE:
      return {
        ...state,
        deleteLocationLoading: false,
        deleteLocationSuccess: false,
        deleteLocationFailure: true,
        deleteLocationError: action.payload,
      };

    default:
      return state;
  }
};
